import styled from "styled-components";
import { T } from "../../theme";

/**
 * Primitivos visuais compartilhados pelas seções da Home.
 * Mantêm largura, espaçamento e tipografia consistentes entre seções.
 */

/* Largura padrão das seções de conteúdo. */
export const Shell = styled.div`
  max-width: 1080px;
  margin: 0 auto;
  padding: 0 clamp(16px, 4vw, 40px);
  width: 100%;
`;

/* Faixa vertical de uma seção. */
export const Band = styled.section`
  padding: clamp(56px, 8vw, 96px) 0;
  ${(p) => p.$soft && `background: ${T.card};`}
  ${(p) => p.$top && `border-top: 1px solid ${T.border};`}
  ${(p) => p.$bottom && `border-bottom: 1px solid ${T.border};`}
`;

export const Eyebrow = styled.p`
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--purple);
  margin-bottom: 12px;
`;

export const Heading = styled.h2`
  font-size: clamp(1.5rem, 3.4vw, 2.2rem);
  font-weight: 900;
  letter-spacing: -0.03em;
  color: ${T.text};
  line-height: 1.12;
  max-width: 640px;
`;

export const Lead = styled.p`
  font-size: clamp(0.92rem, 1.7vw, 1.02rem);
  color: ${T.muted};
  line-height: 1.7;
  max-width: 580px;
  margin-top: 14px;
`;

/* Cabeçalho de seção (eyebrow + título + lead). */
export const Head = styled.div`
  margin-bottom: clamp(32px, 5vw, 48px);
`;
